import axios from 'axios';

// Use relative URL to work with proxy in development and production
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

class PublicApiService {
  private api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  async getLatestDirectionalTheses(
    timeframe: '1_day' | '1_2_weeks' | '1_month' | '6_months_plus',
  ): Promise<any[]> {
    try {
      const response = await this.api.get(
        `/public/analysis/market-thesis/latest/${timeframe}`,
      );
      return response.data || [];
    } catch (error) {
      console.error('Error fetching theses:', error);
      // Return empty array on error so the page still renders
      return [];
    }
  }

  async getDemoAccount(): Promise<{
    account: any;
    positions: any[];
    utilizationSummary: any;
    positionActivityLogs?: Record<string, any[]>;
  }> {
    try {
      const response = await this.api.get(`/public/accounts/demo`);
      return response.data;
    } catch (error) {
      console.error('Error fetching demo account:', error);
      throw error;
    }
  }
}

export const publicApiService = new PublicApiService();

